export const basePath = "/manage-personal-details";

export const pathNames = {
  "/": "/",
  "/residential-address": "/residential-address",
  "/mailing-address": "/mailing-address",
  "/update-email": "/update-email",
  "/error": "/error",
} as const;
